/**
 * Top banners (signed out, sign in again) sit just below the header, not on
 * it: at the top they covered its middle, the "Login to sync" button
 * included (session check, 2026-10-17). Without a header (phone layout) they
 * keep their place from the stylesheet.
 * @param {HTMLElement} banner
 */
export function placeBelowHeader(banner) {
  const header = document.querySelector(".header");
  const bottom = header?.getBoundingClientRect?.().bottom;
  if (bottom > 0) banner.style.top = `${Math.round(bottom) + 8}px`;
}
